module.exports = __webpack_public_path__ + "media/packs/images/flags/OM-b92b5ad816bf191ee2148026ac197010.svg";